import * as generalAPI from '../../../general/api';

export function getTestCases(params) {
  return generalAPI.getTestCases({ cloudType: 'rdc', ...params });
}

export function getTestCasesCSV({ queryParams }) {
  return generalAPI.getTestCasesCSV({ cloudType: 'rdc', queryParams });
}

export function getTestCasesTrends(params) {
  return generalAPI.getTestCasesTrends({ cloudType: 'rdc', ...params });
}
